import React from "react";
import styled from "styled-components";
import FooterLogo from "../../assets/Aqua-logo-white.png";
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from "react-icons/fa";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <TheFooter>
      <div className="footer-container">
        <div className="footer-logo">
          <img src={FooterLogo} alt="footer-logo" />
        </div>

        <div className="footer-links">
          <div className="contact-info">
            <h4>Contact Us</h4>
            <a href="mailto:support@agroharvest.com" className="email">
              <FaEnvelope /> support@agroharvest.com
            </a>
            <a href="tel:+12706320751" className="phone">
              <FaPhone /> +1-270-632-0751
            </a>
            <p className="address">
              <FaMapMarkerAlt /> 8 Cadiz Rd, Hopkinsville, KY 42240
            </p>
          </div>

          <div className="quick-links">
            <h4>Quick Links</h4>
            <a href="/">Home</a>
            <a href="/equipments">Equipments</a>
            <a href="/discover">Discover Us</a>
            <a href="/contact-us">Contact</a>
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms & Conditions</a>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            &copy; {currentYear} AgroHarvest Machineries. All rights reserved.
          </p>
        </div>
      </div>
    </TheFooter>
  );
};

const TheFooter = styled.footer`
  width: 100%;
  height: fit-content;
  background: var(--primary-color);
  color: white;
  padding: 3rem 2rem 1rem;
  margin-top: auto;

  .footer-container {
    max-width: 1400px;
    margin: 0 auto;
  }

  .footer-logo {
    text-align: center;
    margin-bottom: 2rem;

    img {
      max-width: 200px;
      height: auto;
    }
  }

  .footer-links {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
    padding: 2rem 0;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);

    h4 {
      font-size: 1.2rem;
      font-weight: 600;
      margin-bottom: 1rem;
      position: relative;
      display: inline-block;

      &::after {
        content: "";
        position: absolute;
        bottom: -5px;
        left: 0;
        width: 40px;
        height: 2px;
        background: var(--third-color);
      }
    }

    .contact-info {
      display: flex;
      flex-direction: column;
      gap: 0.8rem;

      a,
      p {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        color: white;
        text-decoration: none;
        transition: all 0.3s ease;

        svg {
          font-size: 1rem;
        }

        &:hover {
          color: var(--third-color);
          transform: translateX(5px);
        }
      }

      .address {
        margin: 0;
      }
    }

    .quick-links {
      display: flex;
      flex-direction: column;
      gap: 0.8rem;

      a {
        color: white;
        text-decoration: none;
        transition: all 0.3s ease;

        &:hover {
          color: var(--third-color);
          transform: translateX(5px);
        }
      }
    }
  }

  .footer-bottom {
    text-align: center;
    padding-top: 1.5rem;

    p {
      font-size: 0.9rem;
      opacity: 0.8;
    }
  }

  /* Large desktop screens (1366px and below) */
  @media screen and (max-width: 1366px) {
    padding: 2.5rem 2rem 1rem;

    .footer-links {
      gap: 1.8rem;

      h4 {
        font-size: 1.1rem;
      }
    }
  }

  /* Standard desktop / laptop (1200px and below) */
  @media screen and (max-width: 1200px) {
    padding: 2rem 1.5rem 1rem;

    .footer-links {
      gap: 1.5rem;
    }
  }

  /* Tablets (900px and below) */
  @media screen and (max-width: 900px) {
    padding: 2rem 1.5rem 1rem;

    .footer-links {
      grid-template-columns: repeat(2, 1fr);
      gap: 2rem;
    }

    .footer-logo img {
      max-width: 180px;
    }
  }

  /* Mobile landscape (600px and below) */
  @media screen and (max-width: 600px) {
    padding: 1.5rem 1rem 1rem;

    .footer-links {
      grid-template-columns: 1fr;
      gap: 1.5rem;
      text-align: center;

      .contact-info {
        align-items: center;

        a,
        p {
          justify-content: center;
        }
      }

      .quick-links {
        align-items: center;
      }

      h4 {
        display: block;
        text-align: center;

        &::after {
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }

    .footer-logo img {
      max-width: 150px;
    }

    .footer-bottom p {
      font-size: 0.8rem;
    }
  }

  /* Mobile portrait (420px and below) */
  @media screen and (max-width: 420px) {
    padding: 1.2rem 0.8rem 0.8rem;

    .footer-links {
      gap: 1.2rem;

      .contact-info a,
      .contact-info p,
      .quick-links a {
        font-size: 0.85rem;
      }
    }

    .footer-logo img {
      max-width: 130px;
    }

    .footer-bottom p {
      font-size: 0.7rem;
    }
  }

  /* Small mobile devices (350px and below) */
  @media screen and (max-width: 350px) {
    padding: 1rem 0.5rem 0.5rem;

    .footer-links {
      gap: 1rem;

      h4 {
        font-size: 1rem;
      }

      .contact-info a,
      .contact-info p,
      .quick-links a {
        font-size: 0.75rem;
      }
    }

    .footer-logo img {
      max-width: 110px;
    }
  }
`;

export default Footer;
